import constant from "@/constant";

export default {
  OrderCustomer: {
    name: window.__t('js.don_dat_hang'),
    attribute: {
      code: window.__t('js.ma'),
      order_no: window.__t('js.so_don_hang'),
      client_id: window.__t('js.khach_hang'),
      client: window.__t('js.khach_hang'),
      order_date: window.__t('js.ngay_dat_hang'),
      location_destination: window.__t('js.diem_nhan_hang'),
      location_arrival: window.__t('js.diem_tra_hang'),
      location_destination_id: window.__t('js.diem_nhan_hang'),
      location_arrival_id: window.__t('js.diem_tra_hang'),
      location_destination_detail: window.__t('js.chi_tiet_nhan_hang'),
      location_arrival_detail: window.__t('js.chi_tiet_tra_hang'),
      ETD_date: window.__t('js.ngay_nhan_hang'),
      ETA_date: window.__t('js.ngay_tra_hang'),
      ETA_time: window.__t('js.gio_tra_hang'),
      ETD_time: window.__t('js.gio_nhan_hang'),
    },
  },
  OrderClient: {
    name: window.__t('js.don_dat_hang'),
    attribute: {
      code: window.__t('js.ma'),
      order_no: window.__t('js.so_don_hang'),
      client_id: window.__t('js.khach_hang'),
      client: window.__t('js.khach_hang'),
      order_date: window.__t('js.ngay_dat_hang'),
      location_destination: window.__t('js.diem_nhan_hang'),
      location_arrival: window.__t('js.diem_tra_hang'),
      location_destination_id: window.__t('js.diem_nhan_hang'),
      location_arrival_id: window.__t('js.diem_tra_hang'),
    },
  },
  Client: {
    name: window.__t('js.khach_hang'),
    attribute: {
      tax_code: window.__t('js.ma_so_thue'),
      delegate: window.__t('js.nguoi_dai_dien'),
      customer_code: window.__t('js.ma_khach_hang'),
      full_name: window.__t('js.ho_ten'),
      email: "Email",
      username: window.__t('js.ten_dang_nhap'),
      password: window.__t('js.mat_khau'),
      confirm_password: window.__t('js.xac_nhan_mat_khau'),
      mobile_no: window.__t('js.so_dien_thoai'),
    },
  },
  Staff: {
    name: window.__t('js.nhan_vien'),
    attribute: {
      type: window.__t('js.loai'),
      user_id: window.__t('js.nguoi_dung'),
      avatar_id: window.__t('js.hinh_anh'),
      customer_code: window.__t('js.ma_nhan_vien'),
      full_name: window.__t('js.ho_ten'),
      identity_no: "CMND/CCCD",
      birth_date: window.__t('js.ngay_sinh'),
      email: "Email",
      username: window.__t('js.ten_dang_nhap'),
      password: window.__t('js.mat_khau'),
      mobile_no: window.__t('js.so_dien_thoai'),
    },
  },
  Goods: {
    name: window.__t('js.hang_hoa'),
    attribute: {
      code: window.__t('js.ma'),
      title: window.__t('js.ten'),
      goods_unit: window.__t('js.don_vi'),
      volume: window.__t('js.the_tich'),
      weight: window.__t('js.trong_luong'),
    },
  },
  GoodsUnit: {
    name: window.__t('js.don_vi'),
    attribute: {
      code: window.__t('js.ma'),
      title: window.__t('js.ten'),
      description: window.__t('js.mo_ta'),
    },
  },
  Location: {
    name: window.__t('js.dia_diem'),
    attribute: {
      code: window.__t('js.ma'),
      title: window.__t('js.ten'),
      province: window.__t('js.tinh_thanh_pho'),
      district: window.__t('js.quan_huyen'),
      ward: window.__t('js.phuong_xa'),
    },
  },
  LocationGroup: {
    name: window.__t('js.nhom_dia_diem'),
    attribute: {
      code: window.__t('js.ma'),
      title: window.__t('js.ten'),
      description: window.__t('js.mo_ta'),
    },
  },
  LocationType: {
    name: window.__t('js.loai_dia_diem'),
    attribute: {
      code: window.__t('js.ma'),
      title: window.__t('js.ten'),
      description: window.__t('js.mo_ta'),
    },
  },
  Role: {
    name: window.__t('js.vai_tro'),
  },
  DefaultData: {
    name: window.__t('js.du_lieu_mac_dinh'),
    attribute: {
      client: window.__t('js.khach_hang'),
      location_destination: window.__t('js.diem_nhan_hang'),
      location_destination_ids: window.__t('js.diem_nhan_hang'),
      location_arrival: window.__t('js.diem_nhan_hang'),
      location_arrival_ids: window.__t('js.diem_tra_hang'),
      code: window.__t('js.ma_du_lieu_mac_dinh'),
    },
  },
  LocationDefaultData: {
    name: window.__t('js.dia_chi'),
    attribute: {
      location_destination: window.__t('js.diem_nhan_hang'),
      location_arrival: window.__t('js.diem_nhan_hang'),
      location_type: window.__t('js.loai_dia_diem'),
    },
  },
  Contact: {
    name: window.__t('js.danh_ba'),
    attribute: {
      contact_name: window.__t('js.ho_ten'),
      phone_number: window.__t('js.so_dien_thoai'),
    },
  },
  SettingNotify: {
    name: window.__t('js.thiet_lap'),
    attribute: {},
  },
};
